import { AVAILABLE_LOCALES, LacedAvailableLocales } from 'types/localisation'

const suggestLocale = (
  geoLocale: string, // Geographic IP Location (e.g., 'GB', 'FR', 'US')
  currentLocale: LacedAvailableLocales, // Website's currently set locale (e.g., 'en', 'fr', 'de')
  preferredLocale?: LacedAvailableLocales // User's preferred locale (Set via Cookie or User) (e.g., 'fr', undefined)
): boolean => {
  // Convert geoLocale to lowercase for consistent comparison
  const lowerCaseGeoLocale = geoLocale.toLowerCase()

  // If preferredLocale is defined, return true only if it's different from currentLocale
  if (preferredLocale) {
    return preferredLocale !== currentLocale
  }

  // Locales that trigger return of true (e.g., 'de', 'fr')
  const localesToCheck = ['de', 'fr']

  // Return true if currentLocale is in localesToCheck but geoLocale isn't
  // Example: currentLocale is 'de', geoLocale is 'gb', returns true
  if (
    localesToCheck.includes(currentLocale) &&
    !localesToCheck.includes(lowerCaseGeoLocale)
  ) {
    return true
  }

  // Return false if geoLocale isn't in AVAILABLE_LOCALES
  // Example: geoLocale is 'us', returns false
  if (
    !AVAILABLE_LOCALES.includes(lowerCaseGeoLocale as LacedAvailableLocales)
  ) {
    return false
  }

  // Return true only if geoLocale is different from currentLocale
  // Example: geoLocale is 'fr', currentLocale is 'en', returns true
  return lowerCaseGeoLocale !== currentLocale
}

export default suggestLocale
